import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { assignAgentLead, assignAgentLeadFailure, assignAgentLeadSuccess, fetchLeadsList, fetchLeadsListFailure, fetchLeadsListSuccess } from './leads.action';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class LeadsEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private snackBar: MatSnackBar,
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchLeadsList),
      mergeMap((action:any) =>
        this.CrudService.fetchData(
          `Admin/GetLeads?PageNumber=${action.payload.pageNumber}&PageSize=${action.payload.pageSize}
          &SortColumn=${action.payload.sortColumn}&SortOrder=${action.payload.sortOrder}&Search=${action.payload.search}`).pipe(
          map((result) => fetchLeadsListSuccess({ response: result })),

          catchError((error) => of(fetchLeadsListFailure({ error })))
        )
      )
    )
  );

  assignAgentLead$ = createEffect(() =>
      this.actions$.pipe(
        ofType(assignAgentLead),
        mergeMap((action) =>
          this.CrudService.patchData(
            `Admin/Listing/AssignLeadsToAgent?leadId=${action.payload.id}&agentUserId=${action.payload.agentId}`,
            {}
          ).pipe(
            tap((result) => {
              if (result.successful) {
                this.snackBar.open('Agent assign to lead successfully', '', {
                  duration: 3000,
                  panelClass: 'success',
                });
              } else {
                this.snackBar.open(result.message, '', {
                  duration: 3000,
                  panelClass: 'danger',
                });
              }
            }),
            mergeMap((res) => [
              assignAgentLeadSuccess({ response: res.result }),
              fetchLeadsList({
                payload: {
                  pageNumber: 1,
                  pageSize: 10,
                  sortColumn: 'id',
                  sortOrder: 'z',
                  search: '',
                },
              }),
            ]),
            catchError((error) => {
              return of(assignAgentLeadFailure({ error }));
            })
          )
        )
      )
    );

}
